import { Table, Typography } from 'antd';
import { TransactionGallery } from 'components/TransactionGallery';
import { USDollar, USD_TO_CNY, formatCurrency } from 'utils/format';
const { Text } = Typography;

export function InvestmentTable(props) {
    const {
        investmentsInfo,
        fundTypeToView,
        basicInfo,
        HomeInvestmentTableItemColumns,
        transactions,
        refreshPage,
        expandedRowKeys,
        handleExpand,
    } = props;

    if (investmentsInfo.length === 0) return <></>;

    function InvestmentTableSingleCurrency(props) {
        const { currency } = props;

        const investmentsInfoSingleCurrency = investmentsInfo.filter(
            (investment) =>
                investment.currency.toLowerCase() === currency.toLowerCase()
        );

        if (investmentsInfoSingleCurrency.length === 0) return <></>;

        let data = investmentsInfoSingleCurrency
            .sort((a, b) => {
                if (a.funding_receipt_date !== b.funding_receipt_date) {
                    if (a.funding_receipt_date < b.funding_receipt_date) {
                        return 1;
                    }
                    return -1;
                }
                if (a.actual_redemption_date !== b.actual_redemption_date) {
                    if (a.actual_redemption_date < b.actual_redemption_date) {
                        return 1;
                    }
                    return -1;
                }
                return a.investment_id < b.investment_id ? 1 : -1;
            })
            .map((investment) => {
                return {
                    entity_nameid: basicInfo.legal_name,
                    account: investment.account_name,
                    to_nameid: investment.public_fund_name
                        ? investment.public_fund_name
                        : investment.fund_name,
                    amount: investment.investment_amount,
                    type: investment.investment_type,
                    status: investment.investment_status,
                    dividend_interest_received: investment.interest_received,
                    principal_returned: investment.principal_returned,
                    account_balance: investment.account_balance,
                    // expected_return: 100000,
                    transaction_date: investment.funding_receipt_date,
                    actual_redemption_date: investment.actual_redemption_date,
                    property_name: investment.address,
                    investment_id: investment.investment_id,
                    method:
                        investment.investment_method[0].toUpperCase() +
                        investment.investment_method.slice(1),
                    accountId: investment.account_id,
                    interest: Math.max(
                        investment.interest,
                        investment.overall_interest
                    ),
                    currency: investment.currency,
                };
            })
            .filter((investment) => {
                if (fundTypeToView === 'Both') {
                    return true;
                } else {
                    return investment.type
                        .toLowerCase()
                        .includes(fundTypeToView.toLowerCase());
                }
            });

        if (data.length === 0) {
            return <div style={{ display: 'none' }}></div>;
        }

        return (
            <div>
                <div
                    style={{
                        overflowX: 'scroll',
                        overflow: 'auto',
                        scrollbarWidth: 'auto',
                    }}
                >
                    <div style={{ minWidth: '1700px' }}>
                        <Table
                            bordered
                            size="middle"
                            dataSource={data}
                            columns={HomeInvestmentTableItemColumns}
                            pagination={false}
                            rowKey={(record) => String(record.investment_id)}
                            title={() => (
                                <div
                                    style={{
                                        fontWeight: 'bold',
                                        fontSize: '18px',
                                    }}
                                >
                                    {currency.toUpperCase()} Investment Summary
                                </div>
                            )}
                            expandable={{
                                expandedRowRender: (record) => {
                                    //console.log("HomeInvestmentTableItemColumns records:", record)

                                    const curTransactions = transactions
                                        .filter(
                                            (transactions) =>
                                                transactions.investment_id ==
                                                record.investment_id
                                        )
                                        .sort((a, b) => {
                                            if (a.timestamp < b.timestamp)
                                                return -1;
                                            if (
                                                a.type.toLowerCase() ===
                                                'principal'
                                            )
                                                return 1;
                                            if (
                                                b.type.toLowerCase() ===
                                                'principal'
                                            )
                                                return -1;
                                            return 1;
                                        });
                                    return (
                                        <div>
                                            <ul
                                                style={{
                                                    listStyleType: 'none',
                                                    margin: 0,
                                                }}
                                            >
                                                <li
                                                    style={{
                                                        margin: 0,
                                                        display: 'flex',
                                                        paddingLeft: '30px',
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            width: '100px',
                                                            textAlign: 'center',
                                                        }}
                                                    >
                                                        Est. Date
                                                    </div>
                                                    <div
                                                        style={{
                                                            width: '100px',
                                                            textAlign: 'center',
                                                        }}
                                                    >
                                                        Paid Date
                                                    </div>
                                                    <div
                                                        style={{
                                                            width: '100px',
                                                            textAlign: 'center',
                                                        }}
                                                    >
                                                        Amount
                                                    </div>
                                                    <div
                                                        style={{
                                                            width: '100px',
                                                            textAlign: 'center',
                                                        }}
                                                    >
                                                        Category
                                                    </div>
                                                    <div
                                                        style={{
                                                            width: '100px',
                                                            textAlign: 'center',
                                                        }}
                                                    >
                                                        Status
                                                    </div>
                                                </li>
                                            </ul>
                                            <ul
                                                style={{
                                                    listStyleType: 'none',
                                                    margin: 0,
                                                }}
                                            >
                                                <TransactionGallery
                                                    transactions={[
                                                        ...curTransactions,
                                                    ].reverse()}
                                                    basicInfo={basicInfo}
                                                    accountId={record.accountId}
                                                    accountName={record.account}
                                                    investment_id={
                                                        record.investment_id
                                                    }
                                                    refreshPage={refreshPage}
                                                />
                                            </ul>
                                        </div>
                                    );
                                },
                                rowExpandable: (record) => true,
                                expandedRowKeys,
                                onExpand: handleExpand,
                            }}
                            summary={(rowData) => {
                                return (
                                    <Table.Summary fixed="bottom">
                                        <Table.Summary.Row
                                            style={{ zIndex: 0 }}
                                        >
                                            <Table.Summary.Cell index={0}>
                                                Sum
                                            </Table.Summary.Cell>
                                            <Table.Summary.Cell
                                                align="right"
                                                index={1}
                                                colSpan={8}
                                            >
                                                <Text type="success">
                                                    {formatCurrency(
                                                        rowData
                                                            .map((data) => {
                                                                const value =
                                                                    data.amount ||
                                                                    0;
                                                                return value;
                                                            })
                                                            .reduce(
                                                                (a, b) => a + b
                                                            ),
                                                        currency
                                                    )}
                                                </Text>
                                            </Table.Summary.Cell>
                                            <Table.Summary.Cell
                                                align="right"
                                                index={2}
                                            >
                                                <Text type="success">
                                                    {formatCurrency(
                                                        rowData
                                                            .map((data) => {
                                                                const value =
                                                                    data.dividend_interest_received ||
                                                                    0;
                                                                return value;
                                                            })
                                                            .reduce(
                                                                (a, b) => a + b
                                                            ),
                                                        currency
                                                    )}
                                                </Text>
                                            </Table.Summary.Cell>
                                            <Table.Summary.Cell
                                                align="right"
                                                index={3}
                                            >
                                                <Text type="success">
                                                    {formatCurrency(
                                                        rowData
                                                            .map((data) => {
                                                                const value =
                                                                    data.principal_returned ||
                                                                    0;
                                                                return value;
                                                            })
                                                            .reduce(
                                                                (a, b) => a + b
                                                            ),
                                                        currency
                                                    )}
                                                </Text>
                                            </Table.Summary.Cell>
                                            <Table.Summary.Cell
                                                align="right"
                                                index={4}
                                            >
                                                <Text type="success">
                                                    {formatCurrency(
                                                        rowData
                                                            .map((data) => {
                                                                const value =
                                                                    data.account_balance ||
                                                                    0;
                                                                return value;
                                                            })
                                                            .reduce(
                                                                (a, b) => a + b
                                                            ),
                                                        currency
                                                    )}
                                                </Text>
                                            </Table.Summary.Cell>
                                        </Table.Summary.Row>
                                    </Table.Summary>
                                );
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    }

    function InvestmentSummary() {
        if (investmentsInfo.length === 0) return null;

        const data = investmentsInfo.map((investment) => ({
            amount: investment.investment_amount || 0,
            dividend_interest_received: investment.interest_received || 0,
            principal_returned: investment.principal_returned || 0,
            account_balance: investment.account_balance || 0,
            currency: investment.currency,
        }));

        const sum = (key) =>
            data
                .map((data) => {
                    const value = data[key] || 0;
                    return data.currency.toLowerCase() === 'cny'
                        ? value / USD_TO_CNY
                        : value;
                })
                .reduce((a, b) => a + b, 0);

        return (
            <div>
                <div
                    style={{
                        overflowX: 'scroll',
                        overflow: 'auto',
                        scrollbarWidth: 'auto',
                    }}
                >
                    <div style={{ minWidth: '600px' }}>
                        <div style={{ marginBottom: 24 }}>
                            <Table
                                dataSource={[]} // No rows
                                pagination={false}
                                locale={{ emptyText: null }}
                                className="summary-only-table"
                                title={() => (
                                    <div
                                        style={{
                                            fontWeight: 'bold',
                                            fontSize: '18px',
                                        }}
                                    >
                                        Investment Summary
                                    </div>
                                )}
                                columns={[
                                    {
                                        title: '',
                                        dataIndex: 'summary',
                                        key: 'summary',
                                    },
                                    {
                                        title: 'Invested Amount',
                                        dataIndex: 'amount',
                                        key: 'amount',
                                        align: 'right',
                                    },
                                    {
                                        title: 'Dividends/Interests Received',
                                        dataIndex: 'interest',
                                        key: 'interest',
                                        align: 'right',
                                    },
                                    {
                                        title: 'Principal Returned',
                                        dataIndex: 'principal_returned',
                                        key: 'principal_returned',
                                        align: 'right',
                                    },
                                    {
                                        title: 'Account Balance',
                                        dataIndex: 'account_balance',
                                        key: 'account_balance',
                                        align: 'right',
                                    },
                                ]}
                                summary={() => (
                                    <Table.Summary fixed="bottom">
                                        <Table.Summary.Row>
                                            <Table.Summary.Cell index={0}>
                                                Summary
                                            </Table.Summary.Cell>
                                            <Table.Summary.Cell
                                                align="right"
                                                index={1}
                                                colSpan={1}
                                            >
                                                <Text type="success">
                                                    {formatCurrency(
                                                        sum('amount'),
                                                        'usd'
                                                    )}
                                                </Text>
                                            </Table.Summary.Cell>
                                            <Table.Summary.Cell
                                                align="right"
                                                index={2}
                                            >
                                                <Text type="success">
                                                    {formatCurrency(
                                                        sum(
                                                            'dividend_interest_received'
                                                        ),
                                                        'usd'
                                                    )}
                                                </Text>
                                            </Table.Summary.Cell>
                                            <Table.Summary.Cell
                                                align="right"
                                                index={3}
                                            >
                                                <Text type="success">
                                                    {formatCurrency(
                                                        sum(
                                                            'principal_returned'
                                                        ),
                                                        'usd'
                                                    )}
                                                </Text>
                                            </Table.Summary.Cell>
                                            <Table.Summary.Cell
                                                align="right"
                                                index={4}
                                            >
                                                <Text type="success">
                                                    {formatCurrency(
                                                        sum('account_balance'),
                                                        'usd'
                                                    )}
                                                </Text>
                                            </Table.Summary.Cell>
                                        </Table.Summary.Row>
                                    </Table.Summary>
                                )}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            <div style={{ marginBottom: '20px' }}>
                <InvestmentTableSingleCurrency currency="USD" />
            </div>

            <div style={{ marginBottom: '0px' }}>
                <InvestmentTableSingleCurrency currency="CNY" />
            </div>

            {/* <InvestmentSummary /> */}
        </>
    );
}
